export function readMore () {
    document.querySelectorAll('.readMore').forEach(button => {
        const hiddenText = button?.nextElementSibling;
        button.addEventListener('click', () => {
            $(button).hide()
            $(hiddenText).fadeIn(700)
        })
    });
}